<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<lms-notes-data-list [noteTextParent]='noteTextParent' [loadData]='loadData' [selectedTab]='selectedTab' [subTypes]='subTypes'
    [winCode]="'LWTD'" [notesType]="'T'" [blankMessage]='blankMessage' [errorMessage]='errorMessage'></lms-notes-data-list>